import useCustomEventListener from "./useCustomEventListener";

const COOKIE_UPDATE_EVENT = "cookie-update";

const useLocationEventListener = (callback) => {
    useCustomEventListener(COOKIE_UPDATE_EVENT, callback);
};

export default useLocationEventListener;
